import React, { FC } from 'react';
import styles from './Card.module.css';
import { Typography, TypographyProps } from '../Typography';
import { useThemes } from '@hooks/useThemes';

type CardSubComponents = {
    Title: typeof Title;
    ImageOverlay: typeof ImageOverlay;
};

interface CardProps {
    id?: string;
    classes?: string;
    children?: JSX.Element | JSX.Element[];
}

export const Card: FC<CardProps> & CardSubComponents = ({ id, classes, children }: CardProps) => {
    return (
        <div id={id || undefined} className={`card ${styles.card} ${classes || ''}`} data-testid="card">
            {children}
        </div>
    );
};

interface TitleProps {
    typography: TypographyProps;
    underlineAnimation?: boolean;
}

const Title: FC<TitleProps> = ({ typography, underlineAnimation }) => {
    return (
        <Typography
            {...typography}
            classes={`card-title ${underlineAnimation ? styles['title-underline-animation'] : ''} ${typography.classes || ''}`}
        />
    );
};

interface ImageOverlayProps {
    active?: boolean;
}

// for horizontal bars animation when hovering over card
const ImageOverlay: FC<ImageOverlayProps> = ({ active }) => {
    const { useGrayscaleTheme } = useThemes();

    return (
        <div
            className={`${useGrayscaleTheme ? styles['theme-grayscale'] : ''} ${styles['image-overlay']} ${active ? styles.active : ''}`}></div>
    );
};

Card.Title = Title;
Card.ImageOverlay = ImageOverlay;
